import { DatePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import "../css/rsuit_datetimepicker_custom-1.0.0.css";

const TimeInput = (props) => {
  
  const re = new RegExp("^\\d\\d:\\d\\d");
  if (re.test(props.value)) {
    
    const convertTime12to24 = (time12h) => {
		const [time, modifier] = time12h.split(" ");
	  		let [hours, minutes] = time.split(":");
	
			if (hours === "12") {
			    hours = "00";
			}
			
			if (modifier === "PM") {
			    hours = parseInt(hours, 10) + 12;
			}
	
			return `${hours}:${minutes}:00`;
		};
	const tempDate = new Date();
	const [month, day, year] = tempDate.toLocaleDateString('en-US', {   year: "numeric",   month: "2-digit",   day: "2-digit", }).split('/');
	const [hours, minutes, seconds] = convertTime12to24(props.value).split(':');
	
	props.value = new Date(+year, month - 1, +day, +hours, +minutes, +seconds);


    //props.value = new Date(props.value);

  }
  
  
  function defaultOnFocus(e) {

    if (props.onFocus !== undefined || props.onFocus !== null) {
      props.onFocus(true);
      //return true;
    }
  }

  return (
    <div className="date-time-picker__container" key={props.value}>
      <label
        className={`date-time-picker__label  ${
          props.hasError ? "date-time-picker__label--error" : ""
        }`}
      >
        {props.label}
        <span
          className={`date-time-picker__required  ${
            props.isRequired
              ? "date-time-picker__required--show"
              : "date-time-picker__required--hide"
          }`}
        >
          *
        </span>
      </label>
      <div className="date-time-picker__div">
        <DatePicker
          placeholder="hh:mm am/pm"
          format="hh:mm aa"
          showMeridian
          ranges={[
            {
              label: "Now",
              value: new Date()
            }
          ]}
          style={{ width: 173 }}
          hideMinutes={(minute) => minute % props.increase !== 0}
          size="lg"
          defaultValue={props.value}
          onChange={(time) => props.onChange(time)}
          onBlur={(e) => props.onBlur(e)}
          //onFocus={(e) => (e.target.readOnly = false)}
          onFocus={(e) => defaultOnFocus(e)}
          id={props.id}
	      onClean={props.onClean}
        />
      </div>
      <span
        className="date-time-picker__error"
        style={props.hasError ? {} : { display: "none" }}
      >
        {props.errorMessage}
      </span>
    </div>
  );
};

export default TimeInput;
